<template>
    <div class="qqLogin">
        <iframe :src="thirdLoginUrl"
                frameborder="0"></iframe>
    </div>
</template>

<script>

export default {
    data () {
        return {
            thirdLoginUrl: ''
        }
    },
    mounted () {
        this.qqlogin()
    },
    methods: {
        qqlogin () {
            let t = this
            let d = {
                refer: location.protocol + '//box.yilewan.com/proxy.html',
                self_redirect: 1,
                is_mobile: 0,
                source_page: ELSDK.SourcePage.box || 'yilewan_pcbox',
                attr: t.$cookies.get('jsGameCode') ? 'game' : '',
                attr_value: (t.$cookies.get('jsGameCode') ? t.$cookies.get('jsGameCode') : '').toLowerCase(),
                pid: t.$cookies.get('pid') || t.$cookies.get('jspid') || '',
                show_url: encodeURIComponent(t.fnAddJsPid(location.href)),
                refer_url: encodeURIComponent(t.fnAddJsPid(document.referrer || location.href)),
                dev_type: 3,
                os_type: 1,
                app_code: t.$cookies.get('jsGameCode') ? t.$cookies.get('jsGameCode').toUpperCase() : 120600
            }
            if (t.fnClientInfo('gid') &&
                Number(t.fnClientInfo('gid')) < 99999999 &&
                Number(t.fnClientInfo('gid')) > 1) {
                d.gid = +t.fnClientInfo('gid') || 0
                d.mac = t.fnClientInfo('mac') || ''
                d.pcname = t.fnClientInfo('pcname') || ''
                d.bootid = t.fnClientInfo('bootid') || ''
            }
            let thirdStr = []
            for (let i in d) {
                thirdStr.push(i + '=' + d[i])
            }
            this.thirdLoginUrl = 'https://account-api.yilewan.com/account/login/third/authorization/qq?' + thirdStr.join('&')
        },
        fnAddJsPid (u) {
            let t = this
            let pid = t.$cookies.get('jspid') || ''
            let s = ''
            let uu = ''
            if (u.indexOf('#') > -1) {
                uu = u.split('#')
                u = uu[0]
                s = uu[1]
            }
            if (pid && u.indexOf('pid=') < 0) {
                if (u.indexOf('?') > -1) {
                    u += '&pid=' + pid
                } else {
                    u += '?pid=' + pid
                }
            }
            if (s) {
                if (u.indexOf('?') > -1) {
                    u += '&path=' + s
                } else {
                    u += '?path=' + s
                }
            }
            return u
        },
        fnClientInfo: function (k) {
            var t = ELSDK;
            var wci = JSON.parse(window.clientInfo);
            if (wci[k]) {
                return wci[k];
            } else {
                return '';
            }
        }
    }
}
</script>
